<template>
  <TopLine :style="styleTopline" :title="props.descriptionHeading" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
  <ion-list id="single-option" :style="styleMiddle">

     <ion-radio-group :value="selectedItem" @ionChange="onClick($event)" >
      <div v-for="(item,i) in props.displayArray" :key="item.radio">
      <ion-radio :value="item.radio" :aria-label="item.radio" label-placement="end" class="custom-radio-item">
        <span class="ion-text-wrap">{{ item.name }}</span>
      </ion-radio>
      </div>
    </ion-radio-group>
  </ion-list>
  <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />

</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel , IonRadio,IonRadioGroup } from '@ionic/vue';
  import TopLine from '@/components/TopLine.vue'

  import { computed } from "@vue/reactivity"
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import ToolBar from '@/components/ToolBar.vue'
  import { parseWordsSaid , parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { ref, watch, onMounted } from 'vue'
import { translateEnglishWords } from '@/composables/translation';

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const isDark = ref(connectionStore.getDarkmode != "light")

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  //console.log("is muted in SINGLE options",microphoneIsMuted.value)

  const hasChanges = ref(false)

  const props = defineProps({
    descriptionHeading : {
      type : String,
      default : "GENERIC"
    },
    displayArray : {
      type : Array,
      default : []
    },
    initialSelected : {
      type : String,
      default : "id0"
    },
    wordsSpoken : String,
    wordsSpokenTrigger : Number

  })

  const emit = defineEmits(['item-selected','toolbar-click'])

  const selectedItem = ref(props.initialSelected)

  var displayWordsArray = []
  for (var i=0; i < props.displayArray.length; i++)
    displayWordsArray.push(props.displayArray[i].words)

  const selectedId = ref("")
  var scrollTop = 0
 
  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const TOOLBAR_EXPLAIN = 0

  const toolbarElements = ref([
    { index : TOOLBAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false}
  ])

  const toolbarTrigger = ref(0)

  const descriptionHeading = ref("Blah")
  const topLineTitle = ref(translateEnglishWords("Options"))

  const initialSelected = computed({ get() { return props.initialSelected }})
  const wordsSpoken = computed({ get() { return props.wordsSpoken } })
  const wordsSpokenTrigger = computed({ get() { return props.wordsSpokenTrigger } })

  //const scroll = computed({ get() { return props.scroll } })

  //console.log("props display array",props.displayArray)

  watch(wordsSpokenTrigger, (newVal,oldVal) => {
    //console.log('*********** words spoken changed',props.wordsSpoken)
    processWords(props.wordsSpoken)
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function toplineClick(whatClicked) {
    switch (whatClicked) {
      case "done" :
        //processWords("command done")
        emit("toolbar-click","done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click",microphoneIsMuted.value ? "mute" : "listen")
        break
    }
  }

  function toolbarClick(arrayIndex) {
    //console.log("toolbar click and show state ",arrayIndex)
    switch (arrayIndex) {
      case TOOLBAR_EXPLAIN :
        emit("toolbar-click","explain")
        break
    }
  }

  function onClick(event) {
    //console.log("generic item click",event)
    for (var i=0; i < props.displayArray.length; i++)
      if (event.detail.value == props.displayArray[i].radio) {
        selectedItem.value = props.displayArray[i].radio
        //console.log(" selected index ",i)
        emit('item-selected',i)
        break
      }
  }

  function processWords(text) {
    //console.log("string ",text)
  
    const words = text.split(" ")

    //console.log("words",words,words.length)

    if (words.length == 0)
        return (-1);

    const command = parseGeneralWordsSaid(text,displayWordsArray)
    //console.log("****** command for single option",text,displayWordsArray,command)
  
    switch (command[0]) {
      case "mute" :
        if (microphoneIsMuted.value == true)
          break
        microphoneIsMuted.value = true 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click","mute")
        break
      case "listen" :
        if (microphoneIsMuted.value == false)
          break
        microphoneIsMuted.value = false 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click","listen")
        break
      case "choice" :
        //const databaseValue = props.displayArray[command[1]].value
        //console.log("**** SINGLE VALUE SELECTED -> ",databaseValue)
        //console.log("single voice choice index",command[1])
        emit('item-selected',command[1])
        selectedItem.value = props.displayArray[command[1]].radio
        break
      case "done" :
        //console.log("***** DONE WITH SINGLE CHOICE")
        emit("toolbar-click","done")
        break
      case "explain" :
        emit("toolbar-click","explain")
        break
      case "scroll" :
        scrollElement("single-option",command[1])
        break
    }
  }


</script>

<style scoped>

/*
https://stackoverflow.com/questions/10980822/scrollbar-without-fixed-height-dynamic-height-with-scrollbar
*/

/*
    https://getbootstrap.com/docs/5.0/forms/checks-radios/
*/

.custom-radio-item {
  margin-bottom: 10px; /* Add 10px of space below each item */
}
</style>
